import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAlignmentLeftBar: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAlignmentLeftBar"><Path fillRule="evenodd" clipRule="evenodd" d="M4 4V20H2V4H4ZM8 5H22V7H8V5ZM8 11H22V13H8V11ZM8 17H17V19H8V17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAlignmentLeftBar;
